var map = {
	"./ar/pages/statistics/detailed.js": "9b22",
	"./de/pages/statistics/detailed.js": "1b9b",
	"./en/pages/statistics/detailed.js": "1981",
	"./es/pages/statistics/detailed.js": "530d",
	"./fr/pages/statistics/detailed.js": "91c7",
	"./ja/pages/statistics/detailed.js": "b184",
	"./pt/pages/statistics/detailed.js": "b6d0",
	"./ru/pages/statistics/detailed.js": "c868",
	"./tr/pages/statistics/detailed.js": "021d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3fc7";